'use client';

import { c as _c } from "react/compiler-runtime";
import cx from 'classix';
import { useTranslations } from 'next-intl';
import { DisclosureGroup } from 'react-aria-components';
import rootPageSharedStyles from '@/app/[locale]/root-page-share.module.scss';
import { Link } from '@/i18n/routing';
import FAQ_ITEMS from '@/sections/faq-section/constants/faq-section-constants';
import FaqItem from '@/sections/faq-section/faq-item';
import { DOWNLOAD_APP_LINKS, ROUTER_LINKS } from '@/shared/constants/links-constants';
import styles from './faq-section.module.scss';
export default function FaqSection() {
  const $ = _c(13);
  const faqSectionTranslates = useTranslations("home.faq-section");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = cx(rootPageSharedStyles.section, styles.faqSection);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== faqSectionTranslates) {
    t1 = faqSectionTranslates("title");
    $[1] = faqSectionTranslates;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <header className={rootPageSharedStyles.header}><h2 className={rootPageSharedStyles.title}>{t1}</h2></header>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cx(styles.faqSection_list, "contentText");
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== faqSectionTranslates) {
    t4 = FAQ_ITEMS.map(item => <FaqItem key={item} title={faqSectionTranslates(`items.${item}.question`)} id={item}>{faqSectionTranslates.rich(`items.${item}.answer`, {
        important: _temp,
        li: _temp2,
        linkAndroid: _temp3,
        linkFee: _temp4,
        linkIos: _temp5,
        p: _temp6,
        ul: _temp7
      })}</FaqItem>);
    $[6] = faqSectionTranslates;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <DisclosureGroup className={t3}>{t4}</DisclosureGroup>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t5) {
    t6 = <section className={t0}>{t2}{t5}</section>;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
function _temp7(chunks_5) {
  return <ul>{chunks_5}</ul>;
}
function _temp6(chunks_4) {
  return <p>{chunks_4}</p>;
}
function _temp5(chunks_3) {
  return <Link href={DOWNLOAD_APP_LINKS.appStore}>{chunks_3}</Link>;
}
function _temp4(chunks_2) {
  return <a href={ROUTER_LINKS.terms}>{chunks_2}</a>;
}
function _temp3(chunks_1) {
  return <a href={DOWNLOAD_APP_LINKS.googlePlay}>{chunks_1}</a>;
}
function _temp2(chunks_0) {
  return <li>{chunks_0}</li>;
}
function _temp(chunks) {
  return <strong>{chunks}</strong>;
}